<template>
  <div class="container">
    <h1>Fichiers</h1>

    <div class="row">
      <div class="col-md-3">
        <b-card bg-variant="light">
          <b-card-title class="h5 mb-0 font-weight-normal"
            >Contenu</b-card-title
          >
          <b-card-text class="small text-muted">Dernière version</b-card-text>
          <b-card-text class="font-weight-bold lead text-info">{{
            latestVersions.data ? latestVersions.data.version : 'Inconnu'
          }}</b-card-text>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card bg-variant="light">
          <b-card-title class="h5 mb-0 font-weight-normal">App</b-card-title>
          <b-card-text class="small text-muted">Dernière version</b-card-text>
          <b-card-text class="font-weight-bold lead text-info">{{
            latestVersions.package ? latestVersions.package.version : 'Inconnu'
          }}</b-card-text>
        </b-card>
      </div>
    </div>

    <b-alert variant="info" show class="mt-4">
      <p class="m-0">
        Les versions sont désormais gérées depuis le
        <span class="font-weight-bold">SuperContent</span>.
      </p>
    </b-alert>

    <hr />

    <div class="mt-2">
      <p>Filtrer par:</p>
    </div>
    <div class="d-flex justify-content-start" style="gap: 20px">
      <b-form-group class="" label="Type">
        <b-form-select v-model="type" @change="fetchVersions()">
          <option v-for="(name, value) in types" :key="value" :value="value">
            {{ name }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-group class="" label="Langue">
        <b-form-select v-model="language" @change="fetchVersions()">
          <option
            v-for="(name, value) in languages"
            :key="value"
            :value="value"
          >
            {{ name }}
          </option>
        </b-form-select>
      </b-form-group>
    </div>

    <VersionsTable
      :list="list"
      :fields-only="[
        'id',
        'type',
        'language',
        'version',
        'description',
        'options',
        'preRelease',
        'createdAt',
        'actions',
      ]"
      :general-filters="{ versions: [], language: '' }"
    />

  </div>
</template>

<script>
  import axios from 'axios'
  import { invert } from 'lodash'
  import VersionsTable from '@/components/VersionsTable.vue'
  import { getLanguageSelectOptions } from '@/constants/languages'

  export default {
    name: 'FilesPage',
    components: {
      VersionsTable,
    },
    data() {
      return {
        latestVersions: {
          data: null,
          package: null,
        },

        type: 'data',
        language: null,
        types: [],
        list: [],
      }
    },
    computed: {
      languages() {
        return {
          null: '',
          all: 'Dans toutes les langues uniquement',
          ...getLanguageSelectOptions(),
        }
      },
    },
    mounted() {
      this.fetchAnalytics()
      this.fetchVersionsTypes()
      this.fetchVersions()
    },
    methods: {
      fetchVersionsTypes() {
        axios
          .get('/version/types')
          .then((response) => {
            // this.types = invert(response.data).filter((type) => type !== 'package');
            this.types = invert(response.data)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      fetchVersions() {
        // Add params to url using vue-router
        const params = {}
        if (this.type) {
          params['type'] = this.type
        }
        if (this.language !== null && this.language !== 'null') {
          params['language'] = this.language
        }

        this.$router.push({ query: params })

        axios
          .get('/version', {
            params: {
              type: params['type'] || null,
              language: params['language'] || null,
            },
          })
          .then((response) => {
            this.list = response.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      fetchAnalytics() {
        axios
          .get('/version/analytics')
          .then((response) => {
            Object.keys(this.latestVersions).forEach((type) => {
              if (response.data[type] && response.data[type].latest) {
                this.latestVersions[type] = response.data[type].latest
              } else {
                this.latestVersions[type] = null
              }
            })
          })
          .catch((error) => {
            console.log(error)
          })
      },
    },
  }
</script>

<style></style>
